export default [
  {
    disableBeacon: true,
    target: "#tour-compliance-dropdown",
    title: "Deep Dive into Compliance Requirements",
    content: "The Compliance Manager is your go-to tool for taking a closer look at each requirement from your playbook and checking them off your list.",
    placement: "right"
  },
  {
    target: "#tour-compliance-control",
    title: "Assign tasks and update your compliance status",
    content: "Assign a team member to complete a task, set due dates and set the status of each task to improve your compliance score.",
    placement: "top"
  },
  {
    target: "#tour-compliance-status",
    title: "Watch your compliance score go up!",
    content: "Keep track of your progress with ease. Get real-time updates to your compliance status once a task is completed.",
    placement: "top"
  }
]


// WEBPACK FOOTER //
// ./src/components/tour/compliance/steps.js